var _style, _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadminton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke-width:25;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.8,901L122.8,901c-47.8-47.8-47.8-125.4,0-173.3l94-94L390.1,807l-94,94C248.3,948.9,170.7,948.9,122.8,901 z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 216.9,
    y1: 633.7,
    x2: 437.8,
    y2: 176.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 390.1,
    y1: 807,
    x2: 847.5,
    y2: 586.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "385.6,457.8 345.3,520 250.2,667.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "566.1,638.3 503.9,678.5 356.8,773.7  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "443.9,521 398.5,573.2 286,702.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "502.9,580.1 450.7,625.3 321,737.9  "
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.3,405.1c0,0,78.4-32.4,149-137.5S481,87.1,481,87.1L327.3,405.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M667.4,625.4L667.4,625.4c-35.5,40.5-48.3,71.4-48.3,71.4l318-153.7c0,0-28.9-25.3-75.9-27.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.8,162.6c17.9-2.3,41.9-3.4,66.8,1.1c21.7,31.7,30.8,66.8,33.9,82.4c1.1,5.2,1.5,8.2,1.5,8.2 c-34.2,52.9-84.1,102.6-127.2,140.3c-48.3,42.3-88.3,69.5-88.3,69.5l-10-6.5l-10-6.5c0,0,7.1-40,22.7-94"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M609.5,246.1c17.8,0.4,40.7,2.8,63.7,10.4c13.2,26.6,18.6,54.1,20.8,72.6c1.6,13.5,1.5,22.2,1.5,22.2 c-40.5,46.7-95.6,88.2-143,119.3c-55,36.1-99.8,58.2-99.8,58.2l-9-7.8l-9-7.8c0,0,17.6-53.6,49-118.4c0,0,0,0,0,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M630.7,538.3c-43.2,49.2-71.1,90.1-71.1,90.1l6.5,10l6.5,10c0,0,40.4-7.2,94.8-23 c57.4-16.6,130.3-42.8,187.8-80c0,0,3.5-11.9,5.9-30.1c2.3-17.9,3.5-42-1-67.1c-32.2-22.1-67.9-31-83.1-34.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M552.6,470.5c-36.1,55-58.2,99.8-58.2,99.8l7.8,9l7.8,9c0,0,54.9-18,120.7-50.1 c48.1-23.5,102.1-54.5,144.7-91.5c0,0,2-13.1,1.6-32.6c-0.4-17.8-2.7-41-10.4-64.3c-26.6-13.2-54.1-18.6-72.6-20.8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 295.8,
    y1: 470.4,
    x2: 555.1,
    y2: 729.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadminton);
export default __webpack_public_path__ + "static/media/Badminton.6c170994.svg";
export { ForwardRef as ReactComponent };